import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Directaccess from "./sections/Directaccess";
import InquiryForm from "./sections/InquiryForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Directaccess />
      <InquiryForm />
      <Footer />
    </div>;
}